module.exports = __webpack_public_path__ + "static/media/Acheive2.6733a07d.jpg";